import script from "./SalidaHerramientaCreate.vue?vue&type=script&setup=true&lang=js"
export * from "./SalidaHerramientaCreate.vue?vue&type=script&setup=true&lang=js"

import "./SalidaHerramientaCreate.vue?vue&type=style&index=0&id=3bdbc5fd&scoped=true&lang=css"

import exportComponent from "/home/runner/work/system-jj-frontend/system-jj-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3bdbc5fd"]])

export default __exports__